import cx from 'classnames';
import { Link } from '@dx-ui/global-ui-prism';
import { HeaderLogo } from '../header-logo';
import { useHeaderContext } from '../../context/header-context';
import { sendInteractionReward } from '../../header.utilities';
import { useHeaderStateContext } from '../../context/header-state-context';

type DesktopLogoProps = {
  className?: string;
  anchorClassName?: string;
};

export const DesktopLogo = ({ className, anchorClassName }: DesktopLogoProps) => {
  const { brand } = useHeaderContext();
  const {
    styling: { bottomNavLogoVariant },
    headingLevelProps,
  } = useHeaderStateContext();

  return (
    <div className="flex min-h-[4.5rem] items-center">
      <div {...headingLevelProps} className={className}>
        <Link
          colorTheme="inherit"
          url={brand.url}
          target={brand.target}
          onClick={sendInteractionReward}
          anchorClassName={cx(
            // once nav is implemented on all pages for OHW make w-72 for all brands per UX/UI
            'relative block h-14 w-28 overflow-hidden brand-ee:lg:w-44 brand-ej:lg:w-44 brand-lx:lg:w-44 brand-ou:lg:w-72 brand-yh:lg:w-72',
            anchorClassName
          )}
          showNewWindowIcon={false}
          data-testid="brand-logo-link"
        >
          <HeaderLogo variant={bottomNavLogoVariant} brand={brand} />
        </Link>
      </div>
    </div>
  );
};
